import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { workPositionType } from '@modules/hr-workPositions/_workPositionsEnum';

export default [
  {
    label: 'Pozice',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Nadřízená pozice',
    field: 'supervisor.name',
    displayField: 'supervisor',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Typ pozice',
    field: 'type.id',
    displayField: 'type',
    type: ColumnType.ENUM,
    enum: workPositionType,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/_workPositionsColumns.ts